import Icon from "atoms/icons/icon";
import Paragraph from "atoms/typography/paragraph";
import { t } from "i18next";
import React from "react";
import { Icons } from "atoms/constants/icons";
import { ParagraphSizes } from "atoms/constants/paragraph-sizes";

const CSS_BASE_CLASS = "c-offline-warning-banner";

const OfflineWarningBanner: React.FC = () => {
    return (
        <div className={CSS_BASE_CLASS}>
            <div className={`${CSS_BASE_CLASS}__icon`}>
                <Icon type={Icons.Warning} />
            </div>
            <Paragraph
                cssClassName={`${CSS_BASE_CLASS}__text`}
                size={ParagraphSizes.Small}>
                <b>{t("offline-warning-banner-title")}</b>{" "}
                {t("offline-warning-banner-subtitle")}
            </Paragraph>
        </div>
    );
};

export default OfflineWarningBanner;
